/**
 * @fileoverview Colour swatch picker (MOR-696)
 *
 * A compact row of selectable colour dots constrained to the shared task
 * palette. Used by the task-status and task-label managers (and reusable by
 * the side panel) so colour selection looks identical everywhere.
 */

import { Check } from "lucide-react";
import type { TaskColor } from "@cvx/lib/taskColor.schema";
import { cn } from "@/utils/misc";
import { TASK_COLORS, TASK_COLOR_DOT, taskColorLabel } from "./task-colors";

export function ColorSwatchPicker({
  value,
  onChange,
}: {
  value: TaskColor;
  onChange: (color: TaskColor) => void;
}) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {TASK_COLORS.map((color) => (
        <button
          key={color}
          type="button"
          aria-label={taskColorLabel(color)}
          title={taskColorLabel(color)}
          onClick={() => onChange(color)}
          className={cn(
            "flex size-6 items-center justify-center rounded-full ring-offset-background transition focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
            TASK_COLOR_DOT[color],
            value === color
              ? "ring-2 ring-ring ring-offset-2"
              : "opacity-80 hover:opacity-100",
          )}
        >
          {value === color && <Check className="size-3.5 text-white" />}
        </button>
      ))}
    </div>
  );
}
